import React from "react"
import moment from "moment"
import "./style.scss"

function QuotePanel(props) {
  const { children, styles, className, vendorName } = props
  const quotes = React.Children.toArray(children)
  let classNames = ["quote-panel", className].join(" ")
  return (
    <section className={classNames} styles={styles}>
      {vendorName && (
        <h3 className="quote-title">
          <span>{vendorName}</span> Tracking the Conversation -{" "}
        </h3>
      )}
      <ul className="quote-panel-list">
        {quotes.map((quote, index) => {
          return <li key={index}>{quote}</li>
        })}
      </ul>
    </section>
  )
}

const Quote = (props) => {
  const { quoteData, style, className = "" } = props
  return (
    <article className={`quote-vendor ${className}`} style={style}>
      <blockquote className="quote-vendor-text">{quoteData.text}</blockquote>
      <footer className="quote-vendor-footer">
        <p>
          - {quoteData.speaker}
          <span>
            {` | ${quoteData.eventIdentifier}, ${moment(quoteData.date).format(
              "MM/DD/YYYY"
            )}`}
          </span>
        </p>
      </footer>
    </article>
  )
}

export { QuotePanel, Quote }
